import { render, staticRenderFns } from "./CustomerHistoryShopping.vue?vue&type=template&id=27f922a5&scoped=true&"
import script from "./CustomerHistoryShopping.vue?vue&type=script&lang=js&"
export * from "./CustomerHistoryShopping.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27f922a5",
  null
  
)

export default component.exports